import { createAction } from 'redux-actions';

export const setCalendarAccount = createAction('SET_CALENDAR_ACCOUNT');
